module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "chat"
  }, [_h('div', {
    staticClass: "chat-content"
  }, [_h('ul', {
    ref: "chatOldMessages",
    staticClass: "chat-oldMessages"
  }, [_l((oldEntries), function(entry) {
    return _h('li', {
      key: entry.message,
      staticClass: "chat-message",
      class: {
        'is-user': entry.sender == userName, 'is-bot': entry.sender == botName
      }
    }, [_h('span', {
      staticClass: "sender"
    }, [_s(entry.sender)]), " ", _h('div', {
      staticClass: "messageContents"
    }, [_h('span', {
      staticClass: "messageText"
    }, [_s(entry.message)])])])
  })]), " ", " ", _h('ul', {
    staticClass: "chat-messages"
  }, [_l((entries), function(entry) {
    return _h('li', {
      key: entry.message,
      staticClass: "chat-message is-last",
      class: {
        'is-user': entry.sender == userName, 'is-bot': entry.sender == botName
      }
    }, [_h('span', {
      staticClass: "sender"
    }, [_s(entry.sender)]), " ", _h('div', {
      staticClass: "messageContents"
    }, [_h('span', {
      staticClass: "messageText"
    }, [_s(entry.message)]), " ", _h('div', {
      staticClass: "chat-prompts"
    }, [_l((entry.prompts), function(prompt) {
      return _h('button', {
        on: {
          "click": function($event) {
            promptMessage(prompt)
          }
        }
      }, [_s(prompt)])
    })])])])
  })]), " ", _h('div', {
    staticClass: "inputContainer"
  }, [_h('span', {
    staticClass: "inputLabel",
    class: {
      'stroke': previousAnswerRef === 'lastMessage'
    }
  }, ["Pergunte"]), " ", _h('div', {
    staticClass: "chat-inputform"
  }, [_h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (currentUserMessage),
      expression: "currentUserMessage"
    }],
    ref: "chatInput",
    staticClass: "chat-input",
    attrs: {
      "disabled": previousAnswerRef === 'lastMessage',
      "type": "text"
    },
    domProps: {
      "value": _s(currentUserMessage)
    },
    on: {
      "keyup": function($event) {
        if ($event.keyCode !== 13) return;
        userSendMessage($event)
      },
      "input": function($event) {
        if ($event.target.composing) return;
        currentUserMessage = $event.target.value
      }
    }
  })])])]), " ", _h('a', {
    staticClass: "chat-overlayClose",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": this.dismiss
    }
  }, [_m(0)])])
}},staticRenderFns: [function (){with(this) {
  return _h('i', {
    staticClass: "ion-close"
  })
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-16ca8987!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatbot/ChatWindow.vue
 ** module id = 25
 ** module chunks = 1
 **/